import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import BotCustomReportForm from './BotCustomReportForm';

const BotCustomReportModal = (props) => {
  const { show, setShow, sessionId } = props;

  const onHideModal = () => {
    setShow(false);
  };

  return (
    <Modal show={show} onHide={onHideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Criar Relatório Personalizado</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <BotCustomReportForm
          fileFormat="PDF"
          sessionId={sessionId}
          successCallback={onHideModal}
          hideVariables
        />
      </Modal.Body>
    </Modal>
  );
};

export default BotCustomReportModal;
